export default "__VITE_ASSET__D3vOWF5b__"